module.exports = __webpack_public_path__ + "img/22.a99b3b6f.png";